
; (function () {
    angular.module("EMR.SelectProcedures", []);


    var SelectProceduresRoutes = [
        {
            "name": "SelectProcedures",
            "templateUrl": "<div emr-procedures-select-procedures-popup></div>",
            "RoutingNumber": 1175,
            files: [
                "AngularScripts/SelectProcedures/Directives/SelectProcedures.js",
                "AngularScripts/SelectProcedures/Services/SelectProceduresService.js",
            ]
        }
    ];



    angular.module('EMR.SelectProcedures')
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(SelectProceduresRoutes, $stateProvider);
            }]);
})();